import { Expose } from "class-transformer";

export class CreateAccountingAccountDto {
  @Expose()
  code: string;

  @Expose()
  description: string;

  @Expose()
  counterpartId?: string | null;
}
